import template from './careerCircle.html';
import controller from './careerCircle.controller';
import './careerCircle.styl';

let CareerCircleComponent = () => {
  return {
    template,
    controller,
    controllerAs: 'vm',
    restrict: 'E',
    scope: {
      item: '='
    },
    bindToController: true,
    link: (scope, element) => {
      scope.getWidth = () => {
        return $(element[0].querySelector('.career-item')).width();
      };
      scope.$watch(scope.getWidth, (width) => {
        $(element[0].querySelector('.career-item')).height(width);
        /* Position Popover x-axis with padding (100) */
        let popoverWidth = $(element[0].querySelector('.career-popover')).width() + 100;
        scope.vm.popoverLeft = Math.floor(((width + 11) - popoverWidth) / 2);
      });
    }
  };
};

export default CareerCircleComponent;



// WEBPACK FOOTER //
// ./src/components/careerCircle/careerCircle.component.js